import { Button, Stack } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';
import { Link as RouterLink } from 'react-router';

import { IntermediateExchange } from 'hooks/data/datasets/exchanges/types';
import { useDatasetSession } from 'pages/Dataset/DatasetSessionContext';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';

type Props = {
  baseUrl: string;
  link: IntermediateExchange['link'];
};

const ActivityLink = ({ baseUrl, link }: Props) => {
  const { increment } = useDatasetSession();

  const onClick = () => {
    mixpanel.track(MIXPANEL_EVENTS.EXCHANGE_CLICKED, { base_url: baseUrl, link });
    increment('exchange_clicked_count');
  };

  return (
    <Stack>
      <Button
        wordBreak={'break-word'}
        whiteSpace={'normal'}
        as={RouterLink}
        size="sm"
        variant="link"
        alignSelf={'flex-start'}
        px={0}
        onClick={onClick}
        to={`${baseUrl}${link?.url}/documentation`}
      >
        {link?.name}, {link?.geography}
      </Button>
    </Stack>
  );
};

export default ActivityLink;
